import React, { useState } from "react";
import { Form, Row, Col, Input, notification } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import LoginImage from "../../assets/images/login.svg";
import { LoadingOutlined } from "@ant-design/icons";

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const onLogin = (values) => {
    setLoading(true);
    axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/authentication/login_user?email=${values.email}&password=${values.password}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        console.log("res", res);
        if (res.status == 200) {
          notification["success"]({
            message: "Logged in Successfully",
          });
          localStorage.setItem("UserID", res.data.id);
          if (res.data.role === "Admin") {
            localStorage.setItem("isAdmin", "isAdmin");
            props.history.push("/Activities");
          } else {
            props.history.push("/Dashboard");
          }
          setLoading(false);
        }
      })
      .catch(function (error) {
        notification["error"]({
          message: "Invalid Username Or Password",
        });
        console.log(error);
        setLoading(false);
      });
  };
  return (
    <div className="welcome-page fullscreen">
      <div className="welcome-container">
        <div className="login-wrap">
          <Row gutter={48} align="middle">
            <Col span={14}>
              <img src={LoginImage} alt="" />
            </Col>
            <Col span={10}>
              <div className="login-box">
                <h1>Welcome Back :)</h1>
                <p>
                  To Keep connected with us please login with your personal
                  email address and password.
                </p>
                <br />
                <Form layout="vertical" onFinish={onLogin} hideRequiredMark>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Email!",
                      },
                    ]}
                  >
                    <Input size="large" />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password size="large" />
                  </Form.Item>

                  <Row gutter={15} align="middle">
                    <Col span={12}>
                      <button className="btn btn-theme" htmltype="submit">
                        {loading && <LoadingOutlined />} Login
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default Login;
